import { createApiRef } from "@backstage/core";
import { DiscoveryApi, IdentityApi } from "@backstage/core-plugin-api";
import { CreateIssueInput, JiraProjectResponse } from "../types";
import axios from "axios";

export const jiraApiRef = createApiRef<JiraApi>({
  id: "plugin.jira-api.service",
  description: "Used by plugins to make requests to Jira backend",
});

type Options = {
  discoveryApi: DiscoveryApi;
  identityApi: IdentityApi;
};

export class JiraApi {
  private readonly discoveryApi: DiscoveryApi;
  private readonly identityApi: IdentityApi;

  constructor(options: Options) {
    this.discoveryApi = options.discoveryApi;
    this.identityApi = options.identityApi;
  }

  /** Retrieve the primary URL  */
  private async getUrl(): Promise<string> {
    return await this.discoveryApi.getBaseUrl("jira-api");
  }

  public async getProjectByKey(key: string): Promise<JiraProjectResponse> {
    const { token } = await this.identityApi.getCredentials();
    const response = await axios.get(
      `${await this.getUrl()}/getProjectByKey?key=${key}`,
      { headers: { Authorization: `Bearer ${token}` } }
    );
    return response.data.data;
  }

  public async createIssue(issue: CreateIssueInput): Promise<any> {
    const { token } = await this.identityApi.getCredentials();
    const response = await axios.post(
      `${await this.getUrl()}/createIssue`,
      { issue },
      { headers: { Authorization: `Bearer ${token}` } }
    );
    return response.data;
  }
}
